import { Injectable } from '@angular/core';

import { SelectedDiscount } from '@features/payment';

@Injectable()
export class CheckoutPaymentService {
    public isDiscountBalanceEnough(selectedDiscount: SelectedDiscount[], totalOrder: number): boolean {
        let totalDiscountRaw = 0;
        // biome-ignore lint/complexity/noForEach: <explanation>
        selectedDiscount
            .filter((discount: SelectedDiscount) => discount.enabled)
            .forEach((discount: SelectedDiscount) => {
                totalDiscountRaw += Number.parseInt(discount.discountDetails.values.balance);
            });

        const paymentReady: boolean = totalDiscountRaw >= totalOrder;

        return paymentReady;
    }
}
